module.exports = __webpack_public_path__ + "img/category_cover_Verse.3aca404.webp";